import React, {ReactNode, useEffect, useState} from "react";

export function FormRow({children}: {children: ReactNode}){
    return <div className={'form-row'}>{children}</div>
}
FormRow.Name = ({children}: {children: ReactNode})=> {
    return <p className={'name'}>{children}</p>
}
interface CustomInputInterface extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: string
}
FormRow.Input = React.forwardRef<HTMLInputElement, CustomInputInterface>(
    (props, ref)=> {
        const [errorMessage, setErrorMessage] = useState<string>()

        useEffect(()=> {
            if(props.error){
                setErrorMessage(props.error)
            }else{
                setErrorMessage(undefined)
            }
        }, [props.error])
        return (
            <>
                <input { ...props } onFocus={e=> setErrorMessage(undefined)}/>
                <span className="error-message">{errorMessage && errorMessage || ""}</span>
            </>
        )
    }
)
interface CustomSelectInterface extends React.SelectHTMLAttributes<HTMLSelectElement> {}
FormRow.Select = React.forwardRef<HTMLInputElement, CustomSelectInterface>(
    (props, ref)=> {
        return <select { ...props }/>
    }
)